import { ComboboxAutocomplete } from '@ni/fast-foundation';

export { ComboboxAutocomplete };
